import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { isDefined } from "@omni/utils/helper.utils";
import { fromEntries } from "@omni/utils/object.utils";

import { CalculatorConfig, CalculatorSchema } from "../calculator.types";

export const getFeatures = <TSchema extends CalculatorSchema>(
    product: Product<ProductFieldSet.Full> | undefined,
    config: CalculatorConfig<TSchema>
) => {
    const features = product?.features ?? [];
    const featureCodes = config.variants.flatMap((variant) => variant.codes);

    const featureEntries = features
        .map((feature) => {
            const matchedCode = featureCodes.find((featureCode) =>
                feature.code.endsWith(featureCode)
            );
            if (!matchedCode) return;

            return [matchedCode, feature] as const;
        })
        .filter(isDefined);

    return fromEntries(featureEntries);
};
